<template>
    <div class="ku-cart">
        <div style="text-align: center; font-size: 26px; padding: 10px 0; border-bottom: 1px solid #cc572b;">请您确认如下餐品</div>
        <!-- <div class="ku-top">
            <van-cell title="请您确认如下餐品" v-bind:value="total + '元'" />
        </div> -->

        <div class="goods">
            <div class="goods_for" v-for="(v, i) in cart" :key="i">
                <div class="one">
                    
                    <div class="name">
                        <div class="c1">
                            <span>{{v.name}} {{v.raise_name}}</span>
                        </div>
                        <div class="c2" v-if="v.type === 'combo'">
                            <div class="combo" v-for="(v1, k1) in v.subgoods" :key="k1">
                                <span>{{ v1.name }} {{ v1.raise_name }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="price">{{v.price}}元</div>
                    
                    <van-button class="plus" round icon="plus" color="#D0551B" type="warning" size="mini" @click="plus(v)" />
                    <div class="s1">{{ v.count }}</div>
                    <van-button class="minus" round icon="minus" color="#7DAC2F" type="warning" size="mini" @click="minus(v)" />
                    
                </div>
            </div>
        </div>
        <div class="totalPrice">
            <div>总计：</div>
            <div style="flex: 1; text-align: center; color: #f29600; font-weight: bold;">{{ total + '元' }}</div>
        </div>
        <div class="address" v-show="food_type === 3">
            <van-row>
                <van-col span="14">
                    <van-field v-model="address.mobile" label="电话：" />
                </van-col>
                <van-col span="10">
                    <van-field v-model="address.name" label="尊姓：" />
                </van-col>
                <van-col span="24">
                    <van-field v-model="address.address" :readonly="address_readonly" label="地址：">
                        <template #button>
                            <van-button round v-if="address_readonly" size="small" type="primary" @click="onAddress" color="#C9A063">改地址</van-button>
                        </template>
                    </van-field>
                </van-col>
                <van-col span="24">
                    <van-field v-model="remarks" label="备注：" />
                </van-col>
            </van-row>
        </div>


        
        <div class="tableware">
            <div class="span">餐具<span>1</span>份 <span>{{ tableware }}</span>元</div>
            <van-stepper v-model="tableware_num" theme="round" min="0" button-size="20" disable-input @change="setPrice" />
        </div>

        <div class="tableware" v-if="discount > 0 && (shop_number <= 0 || shop_number == null)">
            <div class="span" style="margin: 0 auto; float: none">使用微信支付可享<span>{{ discount }}</span>折优惠</div>
        </div>

        <div class="footer">
            <div class="f">
                <div style="margin-bottom: 10px;">
                    <van-button type="primary" class="s3" v-show="coType === '1' && food_type === 2" style="margin-right: 10px;" icon="success" icon-position="right">外带</van-button>
                    <van-button type="primary" class="s1" v-show="coType === '1' && food_type !== 2" style="margin-right: 10px;" @click="food_type = 2">外带</van-button>
                    <van-button type="primary" class="s3" v-show="coType === '1' && food_type === 1" icon="success" icon-position="right">堂食</van-button>
                    <van-button type="primary" class="s1" v-show="coType === '1' && food_type !== 1" @click="food_type = 1">堂食</van-button>
                </div>
                <div v-if="shop.offline">
                    <van-button type="primary" class="s4" v-show="food_type" @click="onsubmit(8)">线下支付</van-button>
                </div>
                <div v-else>
                    <van-button type="primary" class="s4" style="margin-right: 10px;" v-show="food_type" @click="onsubmit(2)">微信支付</van-button>
                    <van-button type="primary" class="s2" v-show="food_type && money_check" @click="pay_show = !pay_show">
                        <span>卡支付</span>
                        <label>余{{ money }}元</label>
                        <div class="z1" v-show="pay_show" @click="pay_show = !pay_show">
                            <div v-for="(v, i) in recharge_list" :key="i">
                                <van-button type="primary" :class="{'active': v.coupon}" class="z1-s3" @click="onRecharge(v.id)">
                                    <span>{{v.name}}</span>
                                    <label v-if="v.coupon">{{v.coupon}}</label>
                                </van-button>
                            </div>
                            <van-button type="primary" class="z1-s2" @click="onsubmit(1)">卡支付</van-button>
                        </div>
                    </van-button>
                    

                </div>
                
            </div>
        </div>

        <van-popup closeable v-model="couponPopup" class="coupon">
            <div class="t2">
                <div class="c1" v-for="(v, k) in coupon" :key="k">
                    <div class="p1" :class="{'status-0': v.status === 0}">
                        <span>￥</span>
                        <label>{{ v.money }}</label>
                        <van-button v-if="v.status === 1" type="primary" @click="onsubmitCoupon(v.id)">使用</van-button>
                        <van-button v-else type="primary" @click="shareWx(v.id)">分享激活</van-button>
                        <div class="span-3" v-if="v.min_money > 0">满{{v.min_money}}元可用</div>
                    </div>
                </div>
            </div>

            <div class="c0">
                <van-button @click="onsubmitCoupon(0)" type="primary">不使用</van-button>
            </div>

        </van-popup>

        <van-popup v-model="showPopup" class="csss">
            <van-loading type="spinner" />
        </van-popup>

        <van-overlay :show="shareOverlay" @click="shareOverlay = false">
            <van-image class="share-image" :src="require('@/assets/guide2.png')" />
        </van-overlay>

        <div class="van-sticky" :class="{'van-sticky-1': activity.status > 0}" v-if="activity.status >= 0" @click="onActivity">
            <van-image :src="activity.img" />
            <div class="s1" v-if="activity.status === 0">
                <span>充{{ activity.amount }}元送</span>
                <label>整只潮汕卤猪手</label>
            </div>
            <div class="s1" v-if="activity.status > 0">
                <span>充值成功</span>
                <label>请至前台兑换</label>
            </div>
        </div>

        <van-dialog v-model="offlineShow" title="输入手机号" show-cancel-button :before-close="offlineSubmit">
            <van-field v-model="offline_mobile" label="手机号：" />
        </van-dialog>

        <Drift></Drift>

    </div>
</template>

<script>
import Vue from 'vue';
import {Field, Button, Cell, Dialog, Col, Row, Stepper, Popup, Loading, Overlay, Image as VanImage, Notify } from 'vant';
import {getCookie, setCookie} from "@/utils/auth";
import number from "@/utils/number";
import router from "@/router";
import Drift from "@/components/drift";
import wxApi from "@/utils/wxapi";

Vue.use(Field).use(Cell).use(Button).use(Dialog).use(Col).use(Row).use(Stepper).use(Popup).use(Loading).use(Overlay).use(VanImage).use(Notify);

export default {
    name: "cart",
    data() {
        return {
            shop_id: 0,
            money: 0,
            pay_type: 0,
            showPopup: false,
            couponPopup: false,
            shareOverlay: false,
            offlineShow: false, // 线下支付
            offline_mobile: '', // 线下支付手机号
            coupon_id: 0,
            shop: {},
            cart: [],
            coupon: {},
            discount: 0,
            total: 0,
            type: 1,
            remarks: '',
            food_type: 0, // 1.堂食 2.外带
            pay_show: false,
            money_check: false,
            coType: '0',
            address: {
                id: 0,
                name: '',
                mobile: '',
                address: '',
            },
            user_address: {},
            address_readonly: false,
            tableware: 0,
            tableware_num: 0,
            tableware_price: 0,
            shop_number: 0, // 桌号

            // 微信支付参数
            payConfig: [],
            order_type: 1,
            res_data: [],
            recharge_list: [],
            activity: {
                status: -1,
                amount: 0,
                img: ''
            },

            // 分享参数
            share_title: '',
            share_desc: '',
            share_image: '',
            dre_code: '',
        }
    },
    components: {
        Drift
    },
    mounted() {
        let that = this

        that.shop_id = getCookie('shop_id')
        that.coType = getCookie('coType')

        // 获取用户余额
        that.getUserMoney()
        if (that.coType === '2') {
            that.food_type = 3
        }
        that.$API.getShopInfo({shop_id: that.shop_id}).then(res => {
            return res.data
        }).then(res => {
            that.shop = res.data
            that.tableware = res.data.tableware
            if (that.shop.user_id === 24147) {
                that.money_check = true
            }
        })

        let cart = getCookie('cart_' + this.shop_id) || '';
        if (cart !== 'undefined' && cart !== '') {
            // Math.round(new Date().getTime()/1000)
            let cart_time = getCookie('cart_time_' + this.shop_id)
            if (cart_time !== 'undefined' && cart_time !== '') {
                cart_time = parseInt(cart_time)
                let time = Math.round(new Date().getTime()/1000)
                if ((cart_time + 60 * 60 * 10) > time) {
                    that.cart = JSON.parse(cart)
                } else {
                    that.cart = []
                    setCookie('cart_' + this.shop_id)
                }
            } else {
                that.cart = []
            }
        } else {
            router.push('/goods?shop_id=' + this.shop_id)
        }
        let user_address = getCookie('user_address') || '';
        if (user_address !== 'undefined' && user_address !== '') {
            that.user_address = JSON.parse(user_address)
            that.address = that.user_address
        }

        let amap = getCookie('amap')
        if (amap !== 'undefined' && amap !== '' && amap !== null && amap !== '[]') {
            amap = JSON.parse(amap)
            that.address.lng      = amap.location.lng
            that.address.lat      = amap.location.lat
            that.address.province = amap.province
            that.address.title    = amap.title
        }

        if (that.address.address) {
            that.address_readonly = true
        }

        that.shop_number = parseInt(getCookie('shop_number_' + that.shop_id))
        that.goodsPrice();

    },
    methods: {
        setPrice() {
            let that = this;
            let del_cart = [];
            that.total = 0;
            that.cart.forEach((v, index) => {
                if (v.count <= 0) {
                    del_cart.push(index)
                } else {
                    that.total = that.$number.numberPlus(that.total, v.price)
                }
            });
            del_cart.forEach(vo => {
                that.cart.splice(vo, 1);
            })

            that.tableware_price = that.$number.numberRide(that.tableware_num, that.tableware)
            that.total = that.$number.numberPlus(that.total, that.tableware_price)
            setCookie('cart_' + this.shop_id, JSON.stringify(that.cart))
            setCookie('cart_time_' + this.shop_id, Math.round(new Date().getTime()/1000))
            if (that.cart.length === 0) {
                router.push('/goods?shop_id=' + that.shop_id)
            }
        },
        goodsPrice() {
            let that = this;
            this.total = 0;
            this.cart.forEach(v => {
                v.money = v.price;
                this.total = this.$number.numberPlus(this.total, v.price)
                v.raise_name = ''
                if (v.raise) {
                    let raise = v.raise.split(',');
                    raise.forEach(vs => {
                        let s = vs.split('‡');
                        v.raise_name = v.raise_name + ' *' + s[1]
                    })
                }
                if (v.type === 'combo') {
                    v.subgoods.forEach(v1 => {
                        v1.raise_name = ''
                        if (v1.raise) {
                            let v1raise = v1.raise.split(',');
                            v1raise.forEach(vs1 => {
                                let s = vs1.split('‡');
                                v1.raise_name = v1.raise_name + ' *' + s[1]
                            })
                        }
                    })
                }
            })
            let id = getCookie('address_id')
            if (id > 0) {
                this.$API.getInfoAddress({id: id}).then(res => {
                    return res.data;
                }).then(res => {
                    that.address = res.data
                })
            }
        },
        plus(v) {
            v.count = number.numberPlus(v.count, 1)
            v.price = number.numberRide(v.count, v.money)
            this.setPrice()
        },
        minus(v) {
            if (v.count <= 1) {
                Dialog.confirm({
                    title: '',
                    message: '确认删除餐品吗？',
                }).then(() => {
                    v.count = 0
                    v.price = 0

                    this.setPrice()
                }).catch(() => {})
            } else {
                v.count = number.numberReduce(v.count, 1)
                v.price = number.numberRide(v.count, v.money)
                this.setPrice()
            }
        },
        onsubmit(type) {
            this.pay_type = type
            if (type === 8) {
                this.offlineShow = true
            } else if (type === 2) {
                this.submit(type)
            } else {
                if (this.coupon.length > 0) {
                    this.couponPopup = true
                } else {
                    Dialog.confirm({
                        title: '',
                        message: '确认使用卡支付吗？',
                    }).then(() => {
                        this.submit(type)
                    }).catch(() => {
                    })
                }
            }
        },
        onsubmitCoupon(id) {
            if (id === 0) {
                this.coupon_id = 0
                this.submit(1)
            } else {
                Dialog.confirm({
                    title: '',
                    message: '确认使用优惠券支付吗？',
                }).then(() => {
                    this.coupon_id = id
                    this.submit(1)
                }).catch(() => {
                })
            }
        },
        // 获取用户余额
        getUserMoney() {
            let that = this
            // 获取用户余额
            that.$API.getUserMoney({shop_id: that.shop_id}).then(res => {
                that.money = res.data.data.money
                that.coupon = res.data.data.coupon
                that.dre_code = res.data.data.dre_code
                that.recharge_list = res.data.data.recharge
                that.activity = res.data.data.activity
                that.discount = res.data.data.discount

                that.getSite();
            })
        },
        onActivity() {
            let that = this
            if (this.activity.status === -1) {
                return false;
            } else if (this.activity.status === 0) {
                // 充值
                this.onRecharge(-1)
            } else {
                // 领取
                Dialog.confirm({
                    title: '标题',
                    message: '请确认是否已领取到猪手？',
                }).then(() => {
                    // on confirm
                    that.$API.activity({id: that.activity.status}).then(res => {
                        return res.data;
                    }).then(() => {
                        that.getUserMoney()
                    })
                }).catch(() => {
                    // on cancel
                });
            }
        },
        onRecharge(type) {
            let that = this
            that.showPopup = true
            that.order_type = 2
            that.$API.recharge({type: type, shop_id: that.shop_id}).then(res => {
                return res.data
            }).then(res => {
                if (res.code === 1) {
                    that.payConfig = res.data;
                    if (typeof WeixinJSBridge == "undefined"){
                        if( document.addEventListener ){
                            document.addEventListener('WeixinJSBridgeReady', that.wxpay(res.data), false);
                        }else if (document.attachEvent){
                            document.attachEvent('WeixinJSBridgeReady', that.wxpay(res.data));
                            document.attachEvent('onWeixinJSBridgeReady',that.wxpay(res.data));
                        }
                    }else{
                        that.wxpay();
                    }
                } else {
                    Dialog.alert({
                        message: res.msg,
                    })
                }
            })
        },
        offlineSubmit(action, done) {
            let that = this
            if (action === "confirm") {
                if (that.pay_type === 5 && that.offline_mobile === '') {
                    Notify({ type: 'warning', message: '请输入手机号' });
                    return done(false);
                }
                that.submit(5, done)
            } else {
                return done()
            }
        },
        submit(type, done) {
            let that = this
            that.showPopup = true
            that.show = false
            that.order_type = 1
            that.$API.orderSend({
                order: that.cart,
                shop_id: that.shop_id,
                address: that.address,
                remarks: that.remarks,
                food_type: that.food_type,
                pay_type: this.pay_type,
                tableware: that.tableware_num,
                seat_no: that.shop_number,
                coupon_id: that.coupon_id,
                offline_mobile: that.offline_mobile
            }).then(res => {
                return res.data
            }, () => {
                this.showPopup = false
                return Promise.reject('error')
            }).then(res => {
                if (res.code === 1) {
                    if (!that.user_address.id && res.data.address) {
                        that.user_address.id = res.data.address
                    }
                    setCookie('user_address', JSON.stringify(that.user_address))
                    if (this.pay_type === 2) {
                        that.res_data = res.data;
                        that.payConfig = res.data.pay_url;
                        if (typeof WeixinJSBridge == "undefined"){
                            if( document.addEventListener ){
                                document.addEventListener('WeixinJSBridgeReady', that.wxpay(res.data), false);
                            }else if (document.attachEvent){
                                document.attachEvent('WeixinJSBridgeReady', that.wxpay(res.data));
                                document.attachEvent('onWeixinJSBridgeReady',that.wxpay(res.data));
                            }
                        }else{
                            that.wxpay();
                        }
                    } else {
                        that.onPayOk();
                        that.showPopup = false
                        router.push('/success?no=' + res.data.no + '&order_no=' + res.data.order_no + '&food_type=' + res.data.food_type)
                    }
                } else {
                    that.showPopup = false
                    Dialog.alert({
                        message: '支付失败：' + res.msg,
                    })
                }
            }).catch(err => {
                console.log(err)
                // Notify({type: 'danger', message: err.msg + '1'});
                return done(false);
            })
        },
        wxpay() {
            let that = this;
            /* eslint-disable */
            WeixinJSBridge.invoke(
                "getBrandWCPayRequest",
                {
                    appId: this.payConfig.appId, //公众号名称，由商户传入
                    timeStamp: this.payConfig.timeStamp, //时间戳，自1970年以来的秒数
                    nonceStr: this.payConfig.nonceStr, //随机串
                    package: this.payConfig.package,
                    signType: this.payConfig.signType, //微信签名方式：
                    paySign: this.payConfig.paySign //微信签名
                },
                function(res) {
                    // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                    if(res.err_msg == "get_brand_wcpay_request:ok" ){ //支付成功后的操作
                        Dialog.alert({
                            message: '支付成功',
                        })
                        if (that.order_type === 1) {
                            router.push('/success?no=' + that.res_data.no + '&order_no=' + that.res_data.order_no + '&food_type=' + that.res_data.food_type)
                        } else {
                            // 获取用户余额
                            that.getUserMoney()
                            that.pay_show = false
                        }
                        that.showPopup = false
                    }else if(res.err_msg == 'get_brand_wcpay_request:cancel'){ //取消支付的操作
                        Dialog.alert({
                            message: '取消支付',
                        })
                        that.showPopup = false
                    }else{ //支付失败的操作
                        Dialog.alert({
                            message: '支付失败',
                        })
                        that.showPopup = false
                    }
                    that.show = false
                }
            );
        },
        onPayOk() {
            setCookie('cart_' + this.shop_id);
            setCookie('shop_number_' + this.shop_id, 0) // 删除桌号
        },
        onAddress() {
            router.push('/userAddress')
        },
        getSite() {
            let that = this
            this.$API.commonSite().then(res => {
                return res.data;
            }).then(res => {
                that.share_title = res.data.share_title;
                that.share_desc = res.data.share_desc;
                that.share_image = res.data.share_image;
                that.shareWx(0)
            })
        },
        shareWx(id) {
            let that = this
            let url  = process.env.VUE_APP_USER_URL + '/coupon?id=' + id + '&dre_code=' + that.dre_code
            console.log(url)
            wxApi.wxRegister({
                title: that.share_title, // 分享标题
                link: url, // 分享链接
                imgUrl: that.share_image, // 分享图标
                desc: that.share_desc, // 分享描述
                success: id && that.shareOk
            })
        },
        shareOk() {
            this.couponPopup = false
            this.shareOverlay = true
        }
    },
}
</script>

<style lang="less" scoped>
.ku-cart {
    padding-bottom: 150px;
    .csss {
        background: none;
    }
    .coupon {
        overflow: visible;
        width: 700px;
        padding: 30px 10px;
        background: #E5E5E5;
        border-radius: 20px;
        .t1 {
            height: 50px;
            display: inline-block;
            background: #EA861E;
            margin: 0 auto;
            border: 1px solid white;
            padding: 5px 20px;
            border-radius: 20px;
            span {
                display: inline-block;
                font-size: 25px;
                line-height: 50px;
                color: white;
            }
        }
        .t2 {
            width: 100%;
            margin: 20px auto;
            text-align: left;
            display: inline-block;
            max-height: 500px;
            overflow-y: auto;
            .c1 {
                width: 346px;
                height: 110px;
                margin: 2px 2px;
                background: #BAA58C;
                float: left;
                line-height: 100px;
                position: relative;
                color: #ffffff;
                .p1 {
                    & > span {
                        font-size: 24px;
                        line-height: 24px;
                        position: absolute;
                        left: 10px;
                        top: 10px;

                    }

                    label {
                        font-size: 85px;
                        position: absolute;
                        left: 30px;
                    }

                    .van-button {
                        width: 150px;
                        height: 50px;
                        line-height: 50px;
                        text-align: center;
                        position: absolute;
                        right: 20px;
                        top: 22px;
                        border-radius: 10px;
                        border-color: #fff;
                        background: #009C90;
                        padding: 0 2px;
                    }
                    &.status-0 {
                        color: #806239;
                    }
                    .span-3 {
                        width: 150px;
                        height: 24px;
                        position: absolute;
                        left: 10px;
                        top: 85px;
                        line-height: 24px;
                        z-index: 1;
                        text-align: center;
                        font-size: 20px;
                        color: white;
                    }
                }
            }
        }
        .c0 {
            width: 100%;
            height: 80px;
            margin: 5px 2px;
            line-height: 50px;
            display: block;
            color: white;
            text-align: center;
            .van-button {
                width: 200px;
                height: 80px;
                line-height: 80px;
                border-radius: 10px;
                border-color: #fff;
                background: #806239;
                padding: 0 2px;
                color: white;
            }
        }
        /deep/ .van-popup__close-icon--top-right {
            top: -15px;
            right: -15px;
            width: 50px;
            height: 50px;
            color: white;
            text-align: center;
            line-height: 50px;
            background: red;
            border-radius: 50px;
        }
    }
    .ku-top {
        width: 95%;
        margin: 0 auto;
        .van-cell {
            padding: 10px 0;
            border-bottom: 1px solid #DD5928;
            font-size: 28px;
            .van-cell__title {
                text-align: left;
            }
            .van-cell__value {
                color: #f00;
            }
        }
    }
    .goods {
        width: 100%;
        padding: 0 20px;
        display: inline-block;
        margin: 0 auto;
        box-sizing: border-box;
        .goods_for {
            width: 100%;
            padding: 0;
            float: left;
            .van-button {
                width: 40px;
                height: 40px;
            }
            .one {
                width: 100%;
                min-height: 60px;
                padding: 25px 0 10px 0;
                clear: both;
                font-size: 32px;
                .minus {
                    display: inline-block;
                    float: right;
                }
                .s1 {
                    width: 70px;
                    height: 40px;
                    line-height: 40px;
                    float: right;
                    border: 2px solid #868687;
                    border-radius: 15px;
                    margin-left: 15px;
                    margin-right: 15px;
                }
                .name {
                    width: 400px;
                    float: left;
                    line-height: 40px;
                    text-align: left;
                    font-size: 32px;
                    .c2 {
                        clear: both;
                    }
                }
                .price {
                    width: 120px;
                    float: left;
                    text-align: left;
                }
                .plus {
                    display: inline-block;
                    float: right;
                }
            }
        }
    }
    .totalPrice {
        font-size: 32px; text-align: left; display: flex;box-sizing: border-box; padding: 25px;
        border-bottom: 1px solid #cc572b;
        border-top: 1px solid #cc572b;
    }
    .address {
        width: 95%;
        margin: 0 auto;
        padding: 15px 0;
        text-align: left;
        .van-cell {
            padding: 10px 0 10px 10px;
            /deep/ .van-cell__title {
                width: 90px;
                margin-right: 0;
            }
            /deep/ .van-cell__value {
                border-bottom: 1px solid #ddd;
            }
        }
    }
    .footer {
        width: 100%;
        position: fixed;
        bottom: 20px;
        .f {
            padding: 0 1px;
            .van-button {
                border-radius: 10px;
                padding: 0 10px;
                height: 90px;
                margin-left: 2px;
                font-size: 28px;
                width: 200px;
            }
            .s1 {
                min-width: 120px;
                background-color: #0C9A8F;
                border-color: #0C9A8F;
                i {
                    color: #FFF100;
                }
            }
            .s2 {
                background-color: #754c24;
                border-color: #754c24;
                line-height: 35px;
                position: relative;
                span, label {
                    display: block;
                }
                span {
                    font-size: 26px;
                }
                label {
                    font-size: 24px;
                    color: #EA861E;
                }
            }
            .s3 {
                min-width: 120px;
                background-color: #E45A24;
                border-color: #E45A24;
                i {
                    color: #FFF100;
                }
            }
            .s4 {
                background-color: #008C3A;
                border-color: #008C3A;
            }
            .z1 {
                position: absolute;
                right: 0;
                bottom: calc(100% + 5px);
                width: 200px;
                .van-button {
                    width: 200px;
                    margin-top: 2px;
                }
                .z1-s2 {
                    background-color: #754c24;
                    border-color: #754c24;
                    color: #FFF100;
                }
                .z1-s3 {
                    background-color: #b60b0b;
                    border-color: #b60b0b;
                    &.active {
                        .van-button__text {
                            line-height: 30px;
                            span {

                            }
                            label {
                                font-size: 20px;
                                display: block;
                                color: #EA861E;
                            }
                        }
                    }
                }
            }
        }
    }
    .tableware {
        margin: 10px 0;
        padding: 15px 30px;
        height: 50px;
        border-bottom: 1px solid #ddd;
        .span {
            display: inline-block;
            float: left;
            font: bold 28px/50px 'Microsoft YaHei';
            span {
                color: #ee0a24;
            }
        }
        .van-stepper {
            display: inline-block;
            float: right;
            padding: 6px 0;
        }
    }

    .share-image {
        width: 85%;
    }
    .van-sticky {
        position: fixed;
        bottom: 150px;
        left: 10px;
        display: flex;
        flex-direction: column;
        .van-image {
            width: 250px;
            height: 250px;
        }
        .s1 {
            height: 80px;
            background: #b4272d;
            display: flex;
            flex-direction: column;
            line-height: 40px;
            font-family: "Microsoft YaHei", serif;
            font-size: 30px;
            span {
                color: white;
            }
            label {
                color: #ffff00;
            }
        }
    }
    .van-sticky-1 {
        .s1 {
            background: #333333;
        }
    }
}
</style>
